import request from '@/router/axios'

export function getOSSSign () {
  return request({
    url: '/basic/aliyun/sign',
    method: 'get'
  })
}

export function uploadImage (host, params) {
  return request({
    url: host,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    withCredentials: false,
    data: params
  })
}

export function getOSSPost() {
  return 'image/post/';
}

export function getOSSCircle() {
  return 'image/circle/';
}

export function getOSSAvatar() {
  return 'image/avatar/';
}

export function getOSSBannerRootPath() {
  return 'image/banner/';
}

export function getOSSVideoPost() {
  return 'video/post/';
}

export function getOSSFilePost() {
  return 'file/post/';
}

export function getOSSFileNetdisc() {
  return 'file/netdisc/';
}

export function getOSSFileMaterial() {
  return 'file/material/';
}

export function getOSSVote() {
  return 'image/vote/';
}

export function getOSSActivity() {
  return 'image/activity/';
}

export function getOSSVideoActivity() {
  return 'video/activity/';
}

export function getOSSFileActivity() {
  return 'file/activity/';
}

export function getOSSExam() {
  return 'image/exam/';
}

export function getOSSCourseware() {
  return 'file/courseware/';
}

export function getOSSCourse() {
  return 'image/Course/';
}

export function getOSSFileCourse() {
  return 'file/Course/';
}

export function getOSSVideoCourse() {
  return 'video/Course/';
}

export function getFileNameUUID() {
  const s = [];
  const hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; i += 1) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  const uuid = s.join('');
  return uuid;
}

export function uploadOSSFile(path, formData) {
  return request({
    url: path,
    method: 'POST',
    timeout: 500000,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    withCredentials: false,
    data: formData,
  });
}

/**
 * @param {function} onUploadProgress 监控上传进度
 */
export function uploadOSSFileWithProgress(path, formData, onUploadProgress, isPrivate = false) {
  const headers = {
    'Content-Type': 'multipart/form-data',
  }
  if (isPrivate) {
    headers['x-oss-object-acl'] = 'private';
  }
  return request({
    url: path,
    method: 'POST',
    timeout: 500000,
    headers,
    withCredentials: false,
    data: formData,
    onUploadProgress: onUploadProgress
  })
}

export function downloadOSSFile(param) {
  return request({
    url: '/basic/aliyun/download',
    method: 'GET',
    timeout: 500000,
    responseType: 'blob',
    params: param,
  });
}